import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {customAxios} from "../functions/custom_axios";

const name = 'Speciatilies';
const entity = 'speciatilie';
const entities = 'speciatilies';
const initialState = createInitialState();
const extraActions = createExtraActions();
const extraReducers = createExtraReducers();
const slice = createSlice({ name, initialState, extraReducers });



export const specialitiesActions = { ...slice.actions, ...extraActions };
export const specialitiesReducer = slice.reducer;


function createInitialState() {
    return {
        list: null,
        item: null,
        project_types: null,
        project_statuses: null,
        communicationMode:null,
        listAPIResponse: null
    }
}

function createExtraActions() {
    const baseUrl = `${process.env.REACT_APP_API_URL}`;

    return {
        getAll: getAll(),
        getById: getById(),
        getNewEntity: getNewEntity(),
        create: create(),
        update: update(),
        delete: _delete(),
        getAllProjectTypes: getAllProjectTypes(),
        getAllProjectStatuses: getAllProjectStatuses(),
        getAllCommunicationModes: getAllCommunicationModes(),
        getPaginatedList: getPaginatedList(),
        addProfilesToProject: addProfilesToProject()
    };

    function getAll() {
        return createAsyncThunk(
            `${name}/getAll`,
            async function (args, { getState }) {
                try {
                    const token = getState().auth.value;
                    const headers = {
                        "Authorization": `Bearer ${token}`
                    };
                    // const response = await customAxios.get(`${baseUrl}/api/${entities}`,  {headers});
                    // const responseData = response.data;
                    const responseData = {
                        "totalPages": 1,
                        "totalItems": 2,
                        "list": [
                            {
                                "id": 1,
                                "name": "Oncology",
                                "image_url": "https://www.msd.com/wp-content/uploads/sites/9/2022/09/research-platform-5.jpg?resize=778,519",
                                "total": 12,
                                "status": {
                                    "id": 1,
                                    "name": "Completed",
                                    "sortOrder": 1,
                                    "isActive": 1
                                },
                            },
                            {
                                "id": 2,
                                "name": "Immunology",
                                "image_url": "https://www.cardiff.ac.uk/__data/assets/image/0003/2522883/immunology.jpg",
                                "total": 5,
                                "status": {
                                    "id": 3,
                                    "name": "InProgress",
                                    "sortOrder": 3,
                                    "isActive": 1
                                },
                            },
                            {
                                "id": 3,
                                "name": "Rheumatology",
                                "image_url": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTTyN0HpSpQpYzIlKP1kDjjK9AbKr0_bvHgzQ&s",
                                "total": 17,
                                "status": {
                                    "id": 1,
                                    "name": "Completed",
                                    "sortOrder": 1,
                                    "isActive": 1
                                },
                            },
                            {
                                "id": 4,
                                "name": "Multiple Myeloma",
                                "image_url": "https://mydr.com.au/wp-content/uploads/2014/06/multiple_myeloma_orig-e1559717286664.jpeg",
                                "total": 24,
                                "status": {
                                    "id": 1,
                                    "name": "Completed",
                                    "sortOrder": 1,
                                    "isActive": 1
                                },
                            },
                        ]
                    };

                    return responseData;
                } catch (error) {
                    return [];
                }
            }
        );
    }

    function getById() {
        return createAsyncThunk(
            `${name}/getById`,
            async function (id, { getState }) {
                try {
                    const token = getState().auth.value;
                    const headers = {
                        "Authorization": `Bearer ${token}`
                    };
                    const response = await customAxios.get(`${baseUrl}/api/${entity}/${id}`,  {headers});
                    //const token = response.token;
                    const responseData = response.data;
                    //console.log('responseData: '+ JSON.stringify(responseData));
                    // set auth user in redux state
                    return responseData;
                } catch (error) {
                    return {}
                }
            }

        );
    }

    function getNewEntity() {
        return createAsyncThunk(
            `${name}/getNewEntity`,
            async function (entity, { getState }) {
                //alert('entity: '+JSON.stringify(entity));
                    return entity;
            }
        );
    }

    function create() {
        return createAsyncThunk(
            `${name}/create`,
            async function ({ data }, { getState }) {
                try {
                    const token = getState().auth.value;
                    const headers = {
                        "Authorization": `Bearer ${token}`
                    };
                    const response = await customAxios.post(`${baseUrl}/api/${entity}`, data,  {headers});
                    const responseData = response.data;
                    return responseData;
                } catch (error) {
                    return null;
                }
            }
        );
    }

    function update() {
        return createAsyncThunk(
            `${name}/update`,
            async function ({ id, data }, { getState }) {
                try {
                    const token = getState().auth.value;
                    const headers = {
                        "Authorization": `Bearer ${token}`
                    };
                    const response = await customAxios.put(`${baseUrl}/api/${entity}/${id}`, data,  {headers});
                    const responseData = response.data;
                    return responseData;
                } catch (error) {
                    return {}
                }
            }
        );
    }

    // prefixed with underscore because delete is a reserved word in javascript
    function _delete() {
        return createAsyncThunk(
            `${name}/delete`,
            async function (id, { getState }) {
                try {
                    const token = getState().auth.value;
                    const headers = {
                        "Authorization": `Bearer ${token}`
                    };
                    const response = await customAxios.delete(`${baseUrl}/api/${entity}/${id}`, {headers});
                    const responseData = response.data;
                    return responseData;
                } catch (error) {
                    return {}
                }
            }
        );
    }

    function getAllProjectTypes() {
        return createAsyncThunk(
            `${name}/getAllProjectTypes`,
            async function (args, { getState }) {
                try {
                    const token = getState().auth.value;
                    const headers = {
                        "Authorization": `Bearer ${token}`
                    };
                    const response = await customAxios.get(`${baseUrl}/api/project_types`,  {headers});
                    //const token = response.token;
                    const responseData = response.data;
                    // set auth user in redux state
                    return responseData;
                } catch (error) {
                    return [];
                }
            }
        );
    }

    function getAllProjectStatuses() {
        return createAsyncThunk(
            `${name}/getAllProjectStatuses`,
            async function (args, { getState }) {
                try {
                    const token = getState().auth.value;
                    const headers = {
                        "Authorization": `Bearer ${token}`
                    };
                    const response = await customAxios.get(`${baseUrl}/api/project_statuses`,  {headers});
                    //const token = response.token;
                    const responseData = response.data;
                    // set auth user in redux state
                    return responseData;
                } catch (error) {
                    return [];
                }
            }
        );
    }

    function getAllCommunicationModes() {
        return createAsyncThunk(
            `${name}/getAllCommunicationModes`,
            async function (args, { getState }) {
                try {
                    const token = getState().auth.value;
                    const headers = {
                        "Authorization": `Bearer ${token}`
                    };
                    const response = await customAxios.get(`${baseUrl}/api/communication_modes`,  {headers});
                    //const token = response.token;
                    const responseData = response.data;
                    // set auth user in redux state
                    return responseData;
                } catch (error) {
                    return [];
                }
            }
        );
    }

    function getPaginatedList() {
        return createAsyncThunk(
            `${name}/getPaginatedList`,
            async function (filter, { getState }) {
                try {
                    const token = getState().auth.value;
                    const headers = {
                        "Authorization": `Bearer ${token}`,
                    };
                    // const response = await customAxios.post(`${baseUrl}/api/customized/${entities}`, filter, {headers});
                    // const responseData = response.data;
                    const responseData = {
                        "totalPages": 1,
                        "totalItems": 4,
                        "list": [
                            {
                                "id": 1,
                                "name": "Oncology",
                                "image_url": "https://www.msd.com/wp-content/uploads/sites/9/2022/09/research-platform-5.jpg?resize=778,519",
                                "totalProfilesAdded": 12,
                                "status": {
                                    "id": 1,
                                    "name": "Completed",
                                    "sortOrder": 1,
                                    "isActive": 1
                                },
                            },
                            {
                                "id": 2,
                                "name": "Immunology",
                                "image_url": "https://www.cardiff.ac.uk/__data/assets/image/0003/2522883/immunology.jpg",
                                "totalProfilesAdded": 5,
                                "status": {
                                    "id": 2,
                                    "name": "In Progress",
                                    "sortOrder": 1,
                                    "isActive": 1
                                },
                            },
                            {
                                "id": 3,
                                "name": "Rheumatology",
                                "image_url": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTTyN0HpSpQpYzIlKP1kDjjK9AbKr0_bvHgzQ&s",
                                "totalProfilesAdded": 17,
                                "status": {
                                    "id": 1,
                                    "name": "Completed",
                                    "sortOrder": 1,
                                    "isActive": 1
                                },
                            },
                            {
                                "id": 4,
                                "name": "Multiple Myeloma",
                                "image_url": "https://mydr.com.au/wp-content/uploads/2014/06/multiple_myeloma_orig-e1559717286664.jpeg",
                                "totalProfilesAdded": 24,
                                "status": {
                                    "id": 1,
                                    "name": "Completed",
                                    "sortOrder": 1,
                                    "isActive": 0
                                },
                            },
                        ]
                    };
                    return responseData;
                } catch (error) {
                    return {};
                }
            }
        );
    }

    function addProfilesToProject() {
        return createAsyncThunk(
            `${name}/addProfilesToProject`,
            async function (payload, { getState }) {
                try {
                    const token = getState().auth.value;
                    const headers = {
                        "Authorization": `Bearer ${token}`
                    };

                    const response = await customAxios.post(`${baseUrl}/api/customized/user_project/add_profiles_to_existing_project`, payload,  {headers});
                    const responseData = response.data;
                    return responseData;
                } catch (error) {
                    return {}
                }
            }
        );
    }

}

function createExtraReducers() {
    return (builder) => {
        getAll();
        getById();
        getNewEntity();
        // update();
        _delete();
        getAllProjectTypes();
        getAllProjectStatuses();
        getAllCommunicationModes();
        getPaginatedList();

        function getAll() {
            var { pending, fulfilled, rejected } = extraActions.getAll;
            builder
                .addCase(pending, (state) => {
                    state.list = { loading: true };
                })
                .addCase(fulfilled, (state, action) => {
                    state.list = { value: action.payload };
                })
                .addCase(rejected, (state, action) => {
                    state.list = { error: action.error };
                });
        }

        function getById() {
            var { pending, fulfilled, rejected } = extraActions.getById;
            builder
                .addCase(pending, (state) => {
                    state.item = { loading: true };
                })
                .addCase(fulfilled, (state, action) => {
                    state.item = { value: action.payload };
                })
                .addCase(rejected, (state, action) => {
                    state.item = { error: action.error };
                });
        }

        function getNewEntity() {
            var { pending, fulfilled, rejected } = extraActions.getNewEntity;
            builder
                .addCase(pending, (state) => {
                    state.item = { loading: true };
                })
                .addCase(fulfilled, (state, action) => {
                    state.item = { value: action.payload };
                })
                .addCase(rejected, (state, action) => {
                    state.item = { error: action.error };
                });
        }

        // function update() {
        //     var { pending, fulfilled, rejected } = extraActions.update;
        //     builder
        //         .addCase(pending, (state) => {
        //             state.item = { loading: true };
        //         })
        //         .addCase(fulfilled, (state, action) => {
        //             state.item = { value: action.payload };
        //         })
        //         .addCase(rejected, (state, action) => {
        //             state.item = { error: action.error };
        //         });
        // }

        function _delete() {
            var { pending, fulfilled, rejected } = extraActions.delete;
            builder
                .addCase(pending, (state, action) => {
                    const user = state.list.value.find(x => x.id === action.meta.arg);
                    user.isDeleting = true;
                })
                .addCase(fulfilled, (state, action) => {
                    state.list.value = state.list.value.filter(x => x.id !== action.meta.arg);
                })
                .addCase(rejected, (state, action) => {
                    const user = state.list.value.find(x => x.id === action.meta.arg);
                    user.isDeleting = false;
                });
        }

        function getAllProjectTypes() {
            var { pending, fulfilled, rejected } = extraActions.getAllProjectTypes;
            builder
                .addCase(pending, (state) => {
                    state.project_types = { loading: true };
                })
                .addCase(fulfilled, (state, action) => {
                    state.project_types = { value: action.payload };
                    //alert('Payload: '+JSON.stringify(action.payload));
                })
                .addCase(rejected, (state, action) => {
                    state.project_types = { error: action.error };
                });
        }

        function getAllProjectStatuses() {
            var { pending, fulfilled, rejected } = extraActions.getAllProjectStatuses;
            builder
                .addCase(pending, (state) => {
                    state.project_statuses = { loading: true };
                })
                .addCase(fulfilled, (state, action) => {
                    state.project_statuses = { value: action.payload };
                    //alert('Payload: '+JSON.stringify(action.payload));
                })
                .addCase(rejected, (state, action) => {
                    state.project_statuses = { error: action.error };
                });
        }

        function getAllCommunicationModes() {
            var { pending, fulfilled, rejected } = extraActions.getAllCommunicationModes;
            builder
                .addCase(pending, (state) => {
                    state.communication_modes = { loading: true };
                })
                .addCase(fulfilled, (state, action) => {
                    state.communication_modes = { value: action.payload };
                    //alert('Payload: '+JSON.stringify(action.payload));
                })
                .addCase(rejected, (state, action) => {
                    state.communication_modes = { error: action.error };
                });
        }

        function getPaginatedList() {
            var { pending, fulfilled, rejected } = extraActions.getPaginatedList;
            builder
                .addCase(pending, (state) => {
                    state.listAPIResponse = { loading: true };
                })
                .addCase(fulfilled, (state, action) => {
                    state.listAPIResponse = { value: action.payload };
                })
                .addCase(rejected, (state, action) => {
                    state.listAPIResponse = { error: action.error };
                });
        }

    };



}
